export const groupEls = (self, els) => {
  self._checkNoProcessingTask();
  const grouping = self._getGroupingThrowable();
  return grouping.group(els);
};
